// src/servicerequests/create.js

import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  DateInput,
  FileInput,
  FileField,
  BooleanInput,
  SelectInput,
  ReferenceInput,
  required,
  maxLength,
  useNotify,
  useRedirect,
} from "react-admin";
import { useServicePermissions, SERVICE_STATUS, transformData } from './utils';

const ServiceRequestForm = () => {
  const { canEditStatus, canEditSpareParts } = useServicePermissions();

  return (
    <>
      <ReferenceInput
        label="Producto"
        source="product.id"
        reference="products"
        perPage={1000}
        sort={{ field: "code", order: "ASC" }}
      >
        <SelectInput optionText="fullName" validate={[required()]} />
      </ReferenceInput>

      <DateInput
        source="purchaseDate"
        validate={[required()]}
        options={{
          maxDate: new Date(),
          locale: "es-ES"
        }}
        label="Fecha de Compra"
      />

      <FileInput
        source="invoiceImage"
        label="Factura"
        accept="image/*,application/pdf"
        validate={[required()]}
        placeholder={<p>Adjuntar Foto de la Factura (Campo obligatorio)</p>}
      >
        <FileField source="src" title="title" />
      </FileInput>

      <TextInput
        source="productStatus"
        validate={[required()]}
        label="Estado del Producto"
      />

      {canEditSpareParts && (
        <>
          <BooleanInput
            source="needsSpareParts"
            label="¿Necesita Repuestos?"
          />
          <TextInput
            source="sparePartsDetail"
            label="Detalles de Repuestos"
            multiline
          />
        </>
      )}

      <TextInput
        source="comments"
        label="Comentarios"
        multiline
      />

      <TextInput
        source="clientFirstName"
        validate={[required(), maxLength(100)]}
        label="Nombre del Cliente"
      />

      <TextInput
        source="clientLastName"
        validate={[required(), maxLength(100)]}
        label="Apellido del Cliente"
      />

      <TextInput
        source="clientEmail"
        validate={[required()]}
        label="Email del Cliente"
      />

      {canEditStatus && (
        <SelectInput
          source="status"
          choices={Object.entries(SERVICE_STATUS).map(([key, value]) => ({
            id: value,
            name: value
          }))}
          label="Estado"
        />
      )}
    </>
  );
};

export const ServiceRequestCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Solicitud de servicio creada exitosamente", {
      type: "success",
    });
    redirect("list", "/servicerequests");
  };

  return (
    <Create
      mutationOptions={{ onSuccess }}
      transform={transformData}
    >
      <SimpleForm
        defaultValues={{
          status: SERVICE_STATUS.PENDING
        }}
      >
        <ServiceRequestForm />
      </SimpleForm>
    </Create>
  );
};